import axios from "@/http";

class HumanResoources {
  /* 人力资源列表 */
  static getHumanResourcesList() {
    const url = `/oa/api/labor/list`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 新增公司 */
  static postAddCompany(data) {
    const url = `/oa/api/labor/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 编辑公司 */
  static postModCompany(data) {
    const url = `/oa/api/labor/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default HumanResoources